import { useEffect, useState } from "react";
import { notify } from "../utils/notification";

export const NetworkStatusNotifier = () => {

    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const handleOnline = () => {
        setIsOnline(true);
        notify('success', ' You are back online!')
    };

    const handleOffline = () => {
        setIsOnline(false);
        notify('error', 'Internet connection lost!')
    };

    useEffect(() => {
        // Check initial status on mount
        if (!isOnline) {
            handleOffline();
        }

        // Add event listeners
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        // Clean up event listeners on component unmount
        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <></>
    )
}